import { render, staticRenderFns } from "./perbelanjaanKaumStrata.vue?vue&type=template&id=7dbc3af8&scoped=true"
import script from "./perbelanjaanKaumStrata.vue?vue&type=script&lang=js"
export * from "./perbelanjaanKaumStrata.vue?vue&type=script&lang=js"
import style0 from "./perbelanjaanKaumStrata.vue?vue&type=style&index=0&id=7dbc3af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbc3af8",
  null
  
)

export default component.exports